'use client'
import { memo, useMemo } from 'react'
import styled from 'styled-components'
import { mq, vw, defaultGrid } from '@/styles'
import { Content } from './Content'

const Section = styled.section`
  display: flex;
  flex-wrap: wrap;
  grid-column: 1 / span 6;
  margin-bottom: ${vw(48, 'mobile')};

  ${mq.greaterThan('nexus7')} {
    margin-bottom: ${vw(48, 'tablet')};
  }

  ${mq.greaterThan('tablet')} {
    grid-column: 3 / span 8;
    margin-bottom: ${vw(60, 'desktop')};
  }

  ${mq.greaterThan('desktop')} {
    margin-bottom: 60px;
  }

  > article {
    &.media {
      width: 100%;
    }

    &.text {
      ${mq.greaterThan('tablet')} {
        padding: 0 ${vw(defaultGrid.desktop.columns.width, 'desktop')};
      }

      ${mq.greaterThan('tablet')} {
        padding: 0 ${defaultGrid.desktop.columns.width}px;
      }
    }
  }

  .spacer {
    height: ${vw(40, 'mobile')};

    ${mq.greaterThan('tablet')} {
      height: ${vw(50, 'desktop')};
    }
  }
`

interface IContent {
  type: 'text' | 'empty' | 'media' | 'spacer',
  col: { from: number, expand: number },
  row: { from: number, expand: number },
  text?: string,
  media?: any,
  color?: string,
  align?: { v: string, h: string },
  [key: string]: any
}

interface ISectionContents {
  section: {
    rows: number,
    columns: IContent[]
  },
  className?: string
}

const getContentsByColumns = (columns) => columns.map((content, idx) => {
  return (
    <Content key={idx+'column'} content={content} />
  )
})

export const SectionContents = memo(({ section, className = '' }:ISectionContents) => {
  const { columns } = section
  const ContentsByColumns = useMemo(() => getContentsByColumns(columns), [columns])

  return (
    <Section className={className}>
      {ContentsByColumns}
    </Section>
  )
})
